import axios from "axios";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

const AllAppointmentPricing = () => {
  const [allAppointmentPricing, setAllAppointmentPricing] = useState([]);
  const navigate = useNavigate();
  const API_BASE_URL = process.env.REACT_APP_API_BASEURL;

  useEffect(() => {
    axios
      .get(`${API_BASE_URL}/pricing/appointment`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      })
      .then((result) => {
        console.log(result.data?.data);
        const data = result.data?.data;
        setAllAppointmentPricing(data);
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);

  const handleAddAppointmentPricing = () => {
    navigate("/add-appointment-pricing");
  };

  const handleViewAllAppointmentPricing = () => {
    navigate("/all-appointment-pricing");
  };

  const handleEdit = (id) => {
    navigate(`/edit-appointment-pricing/${id}`);
  };

  const handleDelete = (id) => {
    if (window.confirm("Are you sure you want to delete this item?")) {
      axios
        .delete(`${API_BASE_URL}/pricing/appointment/${id}`, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        })
        .then((response) => {
          alert("Appointment pricing deleted successfully!");
          setAllAppointmentPricing((prevData) =>
            prevData.filter((item) => item._id !== id)
          );
        })
        .catch((error) => {
          console.error("Error deleting appointment pricing:", error);
          alert("Failed to delete appointment pricing. Please try again.");
        });
    }
  };

  return (
    <div id="classes-inner-wrapper">
      <div className="classes-header-div">
        <h5>All Appointment Pricing</h5>
        <div className="subjectdiv2">
          <button
            className="handleNewSubject"
            onClick={handleAddAppointmentPricing}
          >
            + Add New Appointment Pricing
          </button>
          <button
            className="allSubjects"
            onClick={handleViewAllAppointmentPricing}
          >
            All Appointment Pricing
          </button>
        </div>
      </div>

      <div className="classes-table-container">
        <h5>All Appointment Pricing</h5>
        <table className="classes-table">
          <thead>
            <tr>
              <th>S.No.</th>
              <th>Type</th>
              <th>Price</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {allAppointmentPricing.map((data, idx) => (
              <tr key={idx}>
                <td>{idx + 1}</td>
                <td>{data.type}</td>
                <td>{data.price}</td>

                <td className="table-action-icons">
                  <i
                    className="fa-solid fa-file-pen"
                    onClick={() => handleEdit(data._id)}
                  ></i>
                  &nbsp;&nbsp;
                  <i
                    className="fa-solid fa-trash-can"
                    onClick={() => handleDelete(data._id)}
                  ></i>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default AllAppointmentPricing;
